/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnfeatureInputs */

const en_unfeature = /** @type {(inputs: UnfeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unfeature`)
};

const es_unfeature = /** @type {(inputs: UnfeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar destacado`)
};

/**
* | output |
* | --- |
* | "Unfeature" |
*
* @param {UnfeatureInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const unfeature = /** @type {((inputs?: UnfeatureInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnfeatureInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unfeature(inputs)
	return es_unfeature(inputs)
});